<template>
  <div class="page-home container">
    <el-row>
      <el-col :offset="6" :span="12">
        <el-card v-loading="loading" class="has-title">
          <el-form class="mt-4" @submit.native.prevent="updateSetting">
            <h5 class="mb-4">تنظیمات</h5>
            <el-row :gutter="10">
              <el-col :span="24" :xs="24" class="mb-3">
                <label class="font-9">هزینه به ازای هر پیامک</label>
                <currency-input
                  key="form-currency"
                  v-model="form.smsCost"
                  v-validate="'required|numeric|min_value:1'"
                  data-vv-as="هزینه پیامک"
                  currency-name="ریال"
                />
              </el-col>
            </el-row>
            <div class="text-center mt-4">
              <el-button
                type="primary"
                native-type="submit"
                :loading="addLoading"
              >
                ثبت
              </el-button>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CurrencyInput from '@/components/CurrencyInput'

import ReadSmsCostQuery from '@/graphql/settings/ReadSmsCost.gql'
import UpdateSmsCostQuery from '@/graphql/settings/UpdateSmsCost.gql'

export default {
  components: { CurrencyInput },
  data() {
    return {
      loading: true,
      addLoading: false,
      form: {
        smsCost: 0
      }
    }
  },
  created() {
    this.loadSetting()
  },
  methods: {
    loadSetting() {
      this.apollo
        .query({
          query: ReadSmsCostQuery,
          $loadingKey: 'loading'
        })
        .then(response => {
          this.form.smsCost = response.data.result
        })
    },
    updateSetting() {
      this.$validate().then(() => {
        this.apollo
          .mutate({
            query: UpdateSmsCostQuery,
            variables: {
              value: this.form.smsCost
            },
            $loadingKey: 'addLoading'
          })
          .then(() => {
            this.$message.success('تنظیمات بروزرسانی شد')
          })
      })
    }
  }
}
</script>
